<template>
  <div v-redirect-if-no-permission:REGISTERED_CAPTAINS>
    <loading-component :value="loading" />
    <v-layout style="background-color: white; margin-bottom: -10px" justify-end>
      <router-link :to="{ name: 'CreateSurvey' }">
        <v-btn v-if="this.$store.state.user.roles[0].name !== 'Goverment'" color="primary"
          >{{ $t("surveysPage.newSurvey") }}</v-btn
        >
      </router-link>
    </v-layout>
    <data-table
      :url="api.ACTIONS.SURVEYS"
      :enable-edit="false"
      :enable-delete="false"
      :enable-add="false"
      :formatter="formatters"
      :initial-url-search-params="capStatus"
      :actions-extra-main="actionsExtraMain"
      perPage="100"
      :fields-extra-main="surveyOptions"
      :fields-hidden-main="['user_id', 'updated_at', 'deleted_at', 'options', 'answers']"
      :titles="titles"
    />
  </div>
</template>

<script>
import DataTable from "@/components/monaco/DataTable";
import { formatCompanyTime } from "@/util/companyTime";
import Search from "@/components/monaco/SearchAgent";
import ConfirmCaptainDialog from "@/components/monaco/input/ConfirmCaptainDialog";
import LoadingComponent from "@/components/LoadingComponent";
import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

export default {
  name: "Surveys",
  title() {
    return this.$t("surveysPage.surveysTitle");
  },
  components: {
    InterviewCreator,
    LoadingComponent,
    DataTable,
    Search,
    ConfirmCaptainDialog,
  },
  data() {
    return {
      formatters: {
        created_at(value) {
          return formatCompanyTime(value, "DD MMM YYYY");
        },
        end_date(value) {
          return formatCompanyTime(value, "DD MMM YYYY");
        },
      },
      surveys: "",
      surveyOptions: [],
      survey_options: ["yes", "no"],
      survey_answers: [],
      loading: false,
      confirm_dialog: {
        visible: false,
        captain_id: null,
      },
    };
  },
  computed: {
    titles() {
      return {
        id: this.$t("surveysPage.colId"),
        title: this.$t("surveysPage.titleLabel"),
        question: this.$t("surveysPage.questionLabel"),
        created_at: this.$t("surveysPage.startDateLabel"),
        end_date: this.$t("surveysPage.endDateLabel"),
      };
    },
    surveyOptions() {
      return {
        value: this.survey_options,
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("surveysPage.surveyAnswers"),
          icon: "account_circle",
          action: (item) =>
            this.$router.push({
              name: "Survey",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>

<style scoped></style>
